var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',_vm._g(_vm._b({staticClass:"tw-text-xl lg:tw-text-2xl tw-font-bold tw-text-ci-gray-700"},'h2',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }